import { render } from "./RefundConfirm.vue?vue&type=template&id=b88b8a76&scoped=true"
import script from "./RefundConfirm.vue?vue&type=script&lang=js"
export * from "./RefundConfirm.vue?vue&type=script&lang=js"

import "./RefundConfirm.vue?vue&type=style&index=0&id=b88b8a76&scoped=true&lang=css"

import exportComponent from "E:\\zzh\\zl-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88b8a76"]])

export default __exports__